import classNames from "classnames";
import React, { useContext } from "react";
import { RicosContext } from "./../../ricos-context/ricos-context.js";
import {
  VERTICAL_EMBED_BUTTON,
  VERTICAL_EMBED_TITLE
} from "./../data-hooks.js";
import { MAX_BUTTON_TEXT_LENGTH, MAX_RIBBON_TEXT_LENGTH, MAX_TITLE_LENGTH } from "../constants.js";
import styles from "./card-content-scss.js";
import { Description } from "./description.js";
import { Ribbon } from "./ribbon.js";
const CardContent = (props) => {
  const { t } = useContext(RicosContext);
  const { title, buttonText, contentClasses, ribbonPlacement, componentData, ribbonText } = props;
  if (!componentData.cardStyles) {
    componentData.cardStyles = {};
  }
  if (!componentData.cardStyles.titlePriceLayout) {
    componentData.cardStyles.titlePriceLayout = "STACKED";
  }
  const shouldShowButton = !componentData?.hideButton;
  const shouldShowRibbon = !(componentData?.hideRibbon ?? true) && (!ribbonPlacement || ribbonPlacement === "PRODUCT_INFO");
  return /* @__PURE__ */ React.createElement("div", { className: classNames(styles.content, contentClasses) }, /* @__PURE__ */ React.createElement("div", { className: styles.contentText }, shouldShowRibbon && /* @__PURE__ */ React.createElement(RibbonTag, { ribbonText }), /* @__PURE__ */ React.createElement(TitleAndPrice, { title, componentData, t }), /* @__PURE__ */ React.createElement(Description, { componentData })), shouldShowButton && /* @__PURE__ */ React.createElement(ActionButton, { buttonText, t }));
};
const TitleAndPrice = ({
  title,
  componentData,
  t
}) => {
  const shouldShowPricing = componentData.pricingData && !componentData.hidePrice && (componentData.pricingData.valueFrom || componentData.pricingData.discountedValue || componentData.pricingData.pricingPlanId);
  return /* @__PURE__ */ React.createElement("div", { className: styles.titlePriceContainer }, /* @__PURE__ */ React.createElement("div", { className: styles.title, "data-hook": VERTICAL_EMBED_TITLE }, truncateTitle(title)), shouldShowPricing && /* @__PURE__ */ React.createElement(PricingInfo, { pricingData: componentData.pricingData, t }));
};
const PricingInfo = ({
  pricingData,
  t
}) => {
  const { valueFrom, valueTo, discountedValue, currency, pricingPlanId } = pricingData || {};
  const formatPrice = (price) => {
    const numericPrice = parseFloat(price);
    if (isNaN(numericPrice)) {
      return price;
    }
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(numericPrice);
  };
  if (pricingPlanId) {
    return /* @__PURE__ */ React.createElement("div", { className: classNames(styles.pricing, styles.priceOriginal) }, /* @__PURE__ */ React.createElement("span", { className: classNames(styles.price) }, t("VerticalEmbed_Pricing_Plan")));
  }
  return /* @__PURE__ */ React.createElement("div", { className: classNames(styles.pricing, styles.priceOriginal) }, valueTo !== valueFrom && /* @__PURE__ */ React.createElement("span", { className: classNames(styles.price) }, t("VerticalEmbed_From_Price")), valueFrom && /* @__PURE__ */ React.createElement(
    "span",
    {
      className: classNames(styles.price, styles.priceOriginal, {
        [styles.priceStrikethrough]: discountedValue && discountedValue !== valueFrom
      })
    },
    formatPrice(valueFrom)
  ), discountedValue && discountedValue !== valueFrom && /* @__PURE__ */ React.createElement("span", { className: classNames(styles.price, styles.priceDiscounted) }, formatPrice(discountedValue)));
};
const RibbonTag = ({ ribbonText }) => /* @__PURE__ */ React.createElement("div", { className: styles.ribbon }, /* @__PURE__ */ React.createElement(Ribbon, null, truncateRibbonText(ribbonText || "")));
const ActionButton = ({ buttonText }) => /* @__PURE__ */ React.createElement("div", { "data-hook": VERTICAL_EMBED_BUTTON, className: styles.button }, /* @__PURE__ */ React.createElement("div", { className: styles.buttonText }, truncateButtonText(buttonText)));
const truncateTitle = (title) => {
  return title.length <= MAX_TITLE_LENGTH ? title : `${title.substring(0, MAX_TITLE_LENGTH)}...`;
};
const truncateButtonText = (text) => {
  return text.length <= MAX_BUTTON_TEXT_LENGTH ? text : `${text.substring(0, MAX_BUTTON_TEXT_LENGTH)}...`;
};
const truncateRibbonText = (text) => {
  return text.length <= MAX_RIBBON_TEXT_LENGTH ? text : `${text.substring(0, MAX_RIBBON_TEXT_LENGTH)}...`;
};
export {
  CardContent
};
//# sourceMappingURL=card-content.js.map
